"use client";
import React from "react";

const DataStatisticComponent = (data) => {
  const statConfigs = [
    {
      label: "HT-T / FT-T",
      fields: [
        "homeHomeWinWin",
        "homeAwayWinWin",
        "awayHomeWinWin",
        "awayAwayWinWin",
      ],
    },
    {
      label: "HT-T / FT-H",
      fields: [
        "homeHomeWinDraw",
        "homeAwayWinDraw",
        "awayHomeWinDraw",
        "awayAwayWinDraw",
      ],
    },
    {
      label: "HT-T / FT-B",
      fields: [
        "homeHomeWinLose",
        "homeAwayWinLose",
        "awayHomeWinLose",
        "awayAwayWinLose",
      ],
    },
    {
      label: "HT-H / FT-T",
      fields: [
        "homeHomeDrawWin",
        "homeAwayDrawWin",
        "awayHomeDrawWin",
        "awayAwayDrawWin",
      ],
    },
    {
      label: "HT-H / FT-H",
      fields: [
        "homeHomeDrawDraw",
        "homeAwayDrawDraw",
        "awayHomeDrawDraw",
        "awayAwayDrawDraw",
      ],
    },
    {
      label: "HT-H / FT-B",
      fields: [
        "homeHomeDrawLose",
        "homeAwayDrawLose",
        "awayHomeDrawLose",
        "awayAwayDrawLose",
      ],
    },
    {
      label: "HT-B / FT-T",
      fields: [
        "homeHomeLoseWin",
        "homeAwayLoseWin",
        "awayHomeLoseWin",
        "awayAwayLoseWin",
      ],
    },
    {
      label: "HT-B / FT-H",
      fields: [
        "homeHomeLoseDraw",
        "homeAwayLoseDraw",
        "awayHomeLoseDraw",
        "awayAwayLoseDraw",
      ],
    },
    {
      label: "HT-B / FT-B",
      fields: [
        "homeHomeLoseLose",
        "homeAwayLoseLose",
        "awayHomeLoseLose",
        "awayAwayLoseLose",
      ],
    },
  ];

  const renderFields = (fields) => (
    <div className="col-span-2 grid grid-cols-2 gap-1 text-center">
      {fields.map((field, index) => (
        <div key={index} className="bg-white dark:bg-dark-charcoal text-button-blue-bet">
          {data.data[field]}
        </div>
      ))}
    </div>
  );

  return (
    <div className="mt-5">
      <div className="statistic__element">
        <div className="statistic__wrapper grid grid-cols-1 gap-1 text-[8px]">
          <div className="grid grid-cols-5 gap-1 [&>*>*]:px-3 [&>*>*]:py-2 [&>*]:rounded  [&>*>*]:rounded">
            <div className="col-span-1 bg-header-blue dark:bg-league-dark"></div>
            <div className="col-span-2 grid grid-cols-2 gap-1 text-center ">
              <div className="col-span-2 bg-button-blue-bet dark:bg-league-header-dark  text-white">
                {data.match.homeTeam.name}{" "}
              </div>
              <div className="bg-header-blue dark:bg-league-dark text-button-blue-bet">
                Chủ
              </div>
              <div className="bg-header-blue dark:bg-league-dark text-button-blue-bet">
                Khách
              </div>
            </div>
            <div className="col-span-2 grid grid-cols-2 gap-1 text-center ">
              <div className="col-span-2 bg-gradient-start text-button-blue-bet">
                {data.match.awayTeam.name}
              </div>
              <div className="bg-header-blue dark:bg-league-dark text-button-blue-bet">
                Chủ
              </div>
              <div className="bg-header-blue dark:bg-league-dark text-button-blue-bet">
                Khách
              </div>
            </div>
          </div>
          {statConfigs.map(({ label, fields }) => {
            const hasAllFields = fields.every((field) => data.data[field] != null);
            return hasAllFields ? (
              <div
                key={label}
                className="grid grid-cols-5 gap-1 [&>*>*]:px-3 [&>*>*]:py-2 [&>*]:rounded"
              >
                <div className="col-span-1 bg-white dark:bg-dark-charcoal text-button-blue-bet text-center py-2 px-3">
                  {label}
                </div>
                {renderFields(fields.slice(0, 2))}
                {renderFields(fields.slice(2, 4))}
              </div>
            ) : null;
          })}
        </div>
      </div>
    </div>
  );
};

const DataStatistic = ({ match, data }) => {
  return <DataStatisticComponent match={match} data={data} />;
};

export default React.memo(DataStatistic);
